module.exports = __webpack_public_path__ + "static/img/personal.b54dfb16.svg";